import React from 'react';
import { connect } from 'react-redux';
import BuildView from '../../views/buildView/BuildView';
import OptionsPage from '../../common/OptionsPage';
import SimpleOptionGroup from '../../common/options/SimpleOptionGroup';
import { Accordion } from 'core/controls/accordion/Accordion';
import InteriorCgi from '../../components/interiorCgi/InteriorCgi';
import {
  computeDefaultAngle,
  computeImageSize,
} from '../../common/cgi/cgiHelpers';
import { template } from 'lodash';
import { cgiDimensions } from '../../common/cgi/Cgi';
import { useNavigate } from 'react-router-dom';
import { INTERIOR } from '../../common/steps';

const Interior = ({
  interior,
  bottomOffset,
  breakpoint,
  cgiSize,
  exteriorAngles,
  interiorAngles,
  wheelAngles,
  moreViewsPath,
}) => {
  const categories = interior.categories;
  const isDisplayOnly = categories.length === 1;

  const { cgiImageUrl } = interior;

  const imageSize = computeImageSize(breakpoint, cgiSize);
  const angle = computeDefaultAngle(
    null,
    exteriorAngles,
    interiorAngles,
    wheelAngles,
    true
  );

  const cgi = {
    url: template(cgiImageUrl)({
      imageSize,
      degree: angle,
      removeCat: '',
    }),
    dimensions: cgiDimensions[imageSize],
  };

  const getOptions = () => {
    return (
      <OptionsPage>
        {({ onChange, onDetails, isUpdating, selectingOption }) => (
          <Accordion>
            {categories.map((category, index) => (
              <SimpleOptionGroup
                key={category.label}
                header={category.label}
                analyticsKey={category.label}
                options={category.options}
                id={category.key}
                onChange={onChange}
                onDetails={onDetails}
                displayOnly={index === 0 ? isDisplayOnly : false}
                isOpenDefault={category.expanded}
                isUpdating={isUpdating}
                selectingOption={selectingOption}
              />
            ))}
          </Accordion>
        )}
      </OptionsPage>
    );
  };

  const navigate = useNavigate();

  const onClick = () => {
    navigate(`${moreViewsPath?.pathname}${moreViewsPath?.search}`);
  };

  return (
    <BuildView
      onload={() => {}}
      interiorView
      bottomOffset={bottomOffset}
      cgi={<InteriorCgi cgi={cgi} onClick={onClick} />}
      options={getOptions()}
      step={INTERIOR}
    />
  );
};

const mapStateToProps = (state) => {
  const { breakpoint } = state;
  const { interior } = state.config;
  const {
    cgiSize,
    exteriorAngles,
    interiorAngles,
    wheelAngles,
  } = state.appResources;

  return {
    interior,
    breakpoint,
    cgiSize,
    exteriorAngles,
    interiorAngles,
    wheelAngles,
  };
};

export default connect(mapStateToProps)(Interior);
